import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23bb001e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "links-alerting" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "equipment card-title" }, "Equipments alerts", -1 /* HOISTED */))
const _hoisted_4 = { class: "q-pa-md" }
const _hoisted_5 = { class: "q-mr-sm" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1 /* HOISTED */))
const _hoisted_7 = {
  "aria-label": "alert-table",
  class: "sensors-details"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { id: "pi-vision" }),
    /*#__PURE__*/_createElementVNode("th", { id: "sensor-tag" }, "Sensor Tag"),
    /*#__PURE__*/_createElementVNode("th", { id: "sensor-name" }, "Sensor Name"),
    /*#__PURE__*/_createElementVNode("th", { id: "normal-value" }, "Recent Value"),
    /*#__PURE__*/_createElementVNode("th", { id: "drift-value" }, "Drift Value"),
    /*#__PURE__*/_createElementVNode("th", { id: "trip-value" }, "Trip Value"),
    /*#__PURE__*/_createElementVNode("th", { id: "deviation-ratio" }, "Deviation (%)")
  ])
], -1 /* HOISTED */))
const _hoisted_9 = { class: "pi-vision" }
const _hoisted_10 = { class: "q-mr-lg status-info" }
const _hoisted_11 = { class: "q-mr-lg status-info" }
const _hoisted_12 = { class: "q-mr-lg status-info" }
const _hoisted_13 = { class: "q-mr-lg status-info" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "q-mr-lg status-info" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "q-mr-lg status-info" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Keyword Search", -1 /* HOISTED */))
const _hoisted_21 = { class: "q-ml-md" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Filter by Alert", -1 /* HOISTED */))
const _hoisted_23 = { class: "q-ml-md" }
const _hoisted_24 = { class: "row items-center q-gutter-xs" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Export", -1 /* HOISTED */))
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Export as Excel")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Export as JSON")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinksCard = _resolveComponent("LinksCard")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_AlertFeedbackSelector = _resolveComponent("AlertFeedbackSelector")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_RealAlertPopin = _resolveComponent("RealAlertPopin")!
  const _component_NormalBehaviorPopin = _resolveComponent("NormalBehaviorPopin")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_LinksCard, { equipment: _ctx.currentSelectedEquipment }, null, 8 /* PROPS */, ["equipment"])
    ]),
    _createVNode(_component_q_card, { class: "equipments-alerting" }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card_section, null, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_q_separator),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_q_table, {
            pagination: _ctx.pagination,
            "onUpdate:pagination": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.pagination) = $event)),
            rows: _ctx.equipmentMlStatusesClone,
            columns: _ctx.columns,
            "row-key": "equipment",
            filter: _ctx.filter,
            "loading-label": "Fetching Data!",
            "data-test": "equipment-MlStatuses-table",
            loading: _ctx.loading,
            class: "abc",
            onRequest: _ctx.onRequest
          }, {
            "top-right": _withCtx((scope) => [
              _createElementVNode("span", _hoisted_5, "Page: " + _toDisplayString(scope.pagination.page) + " / " + _toDisplayString(scope.pagesNumber), 1 /* TEXT */),
              (scope.pagesNumber > 2)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 0,
                    icon: "first_page",
                    color: "grey-8",
                    round: "",
                    dense: "",
                    flat: "",
                    disable: scope.isFirstPage,
                    onClick: scope.firstPage
                  }, null, 8 /* PROPS */, ["disable", "onClick"]))
                : _createCommentVNode("v-if", true),
              _createVNode(_component_q_btn, {
                icon: "chevron_left",
                color: "grey-8",
                round: "",
                dense: "",
                flat: "",
                disable: scope.isFirstPage,
                onClick: scope.prevPage
              }, null, 8 /* PROPS */, ["disable", "onClick"]),
              _createVNode(_component_q_btn, {
                icon: "chevron_right",
                color: "grey-8",
                round: "",
                dense: "",
                flat: "",
                disable: scope.isLastPage,
                onClick: scope.nextPage
              }, null, 8 /* PROPS */, ["disable", "onClick"]),
              (scope.pagesNumber > 2)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 1,
                    icon: "last_page",
                    color: "grey-8",
                    round: "",
                    dense: "",
                    flat: "",
                    disable: scope.isLastPage,
                    onClick: scope.lastPage
                  }, null, 8 /* PROPS */, ["disable", "onClick"]))
                : _createCommentVNode("v-if", true)
            ]),
            header: _withCtx((props) => [
              _createVNode(_component_q_tr, { props: props }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col) => {
                    return (_openBlock(), _createBlock(_component_q_th, {
                      key: col.name,
                      props: props
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(col.label), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["props"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["props"])
            ]),
            body: _withCtx((props) => [
              _createVNode(_component_q_tr, {
                props: props,
                class: _normalizeClass(_ctx.rowClass(props.row.unread))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_td, {
                    key: "unread",
                    class: "td-unread",
                    props: props,
                    onClick: ($event: any) => (
                  _ctx.updateStatus(
                    props.row.equipment.id,
                    props.row.id,
                    !props.row.unread,
                    props.row.feedback
                  )
                )
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_btn, {
                        disable: _ctx.isUserUnknownOrGuestOrOffshore(),
                        dense: "",
                        round: "",
                        flat: "",
                        color: "black",
                        icon: props.row.unread ? 'flag' : 'o_flag',
                        debounce: "300"
                      }, null, 8 /* PROPS */, ["disable", "icon"])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["props", "onClick"]),
                  _createVNode(_component_q_td, {
                    key: "date",
                    props: props,
                    class: "date-td"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.formatDate(props.row.firstDriftDate)), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["props"]),
                  _createVNode(_component_q_td, {
                    key: "equipment",
                    props: props,
                    class: "cursor-pointer",
                    onClick: ($event: any) => (_ctx.onEquipmentNameClick(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(props.row.equipmentName), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["props", "onClick"]),
                  _createVNode(_component_q_td, {
                    key: "type",
                    props: props
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_AlertFeedbackSelector, {
                        "is-disabled": _ctx.isUserUnknownOrGuestOrOffshore(),
                        "equipment-ml-status": props.row,
                        onOnRealAlert: _cache[0] || (_cache[0] = ($event: any) => (_ctx.displayRealAlertPopin(true))),
                        onOnNormalBehavior: _cache[1] || (_cache[1] = ($event: any) => (_ctx.displayNormalBehaviorPopin(true)))
                      }, null, 8 /* PROPS */, ["is-disabled", "equipment-ml-status"])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["props"]),
                  _createVNode(_component_q_td, {
                    key: "downloadPlot",
                    props: props
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.isUserUnknownOrGuestOrOffshore())
                        ? (_openBlock(), _createBlock(_component_q_btn, {
                            key: 0,
                            outline: "",
                            rounded: "",
                            "no-caps": "",
                            class: "main-button",
                            label: "Download plot",
                            onClick: ($event: any) => (_ctx.downloadPlot(props.row.plotPath))
                          }, null, 8 /* PROPS */, ["onClick"]))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["props"]),
                  _createVNode(_component_q_td, { "auto-width": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        size: "sm",
                        class: "red cursor-pointer q-mr-xl",
                        name: props.expand ? 'expand_less' : 'expand_more',
                        onClick: ($event: any) => (props.expand = !props.expand)
                      }, null, 8 /* PROPS */, ["name", "onClick"])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["props", "class"]),
              _withDirectives(_createVNode(_component_q_tr, { props: props }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_td, { class: "td-table-border" }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_q_td, {
                    colspan: "100%",
                    class: "td-table-sensors"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("table", _hoisted_7, [
                        _hoisted_8,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.sensorStatuses, (status) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: status.id
                            }, [
                              _createElementVNode("td", _hoisted_9, [
                                _createVNode(_component_q_btn, {
                                  outline: "",
                                  rounded: "",
                                  "no-caps": "",
                                  class: "main-button",
                                  label: "PI Vision",
                                  onClick: ($event: any) => (_ctx.piVisionLink(status.sensor?.name))
                                }, null, 8 /* PROPS */, ["onClick"])
                              ]),
                              _createElementVNode("td", _hoisted_10, _toDisplayString(status.sensor?.name), 1 /* TEXT */),
                              _createElementVNode("td", _hoisted_11, _toDisplayString(status.sensor?.description), 1 /* TEXT */),
                              _createElementVNode("td", _hoisted_12, _toDisplayString(Number(status.normalValue)?.toFixed(2)) + " " + _toDisplayString(status.sensor?.unit), 1 /* TEXT */),
                              _createElementVNode("td", _hoisted_13, [
                                (status.driftValue !== null)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(Number(status.driftValue)?.toFixed(2)) + " " + _toDisplayString(status.sensor?.unit), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _createElementVNode("td", _hoisted_15, [
                                (status.sensor?.tripHigh !== null)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(Number(status.sensor?.tripHigh)?.toFixed(2)) + " " + _toDisplayString(status.sensor?.unit), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _createElementVNode("td", _hoisted_17, [
                                (status?.deviationRatio !== null)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(status?.deviationRatio), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true)
                              ])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["props"]), [
                [_vShow, props.expand]
              ])
            ]),
            "body-cell-unread": _withCtx((props) => [
              _createVNode(_component_q_td, { props: props }, {
                default: _withCtx(() => [
                  (props.row.unread)
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 0,
                        dense: "",
                        round: "",
                        flat: "",
                        color: "black",
                        icon: "flag",
                        debounce: "300"
                      }))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["props"])
            ]),
            "top-left": _withCtx(() => [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", null, [
                  _hoisted_20,
                  _createVNode(_component_q_input, {
                    modelValue: _ctx.filter,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filter) = $event)),
                    class: "search-input",
                    clearable: "",
                    outlined: "",
                    onInput: _ctx.onKeywordInput,
                    onClear: _ctx.onKeywordClear
                  }, {
                    append: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        name: "search",
                        onClick: _ctx.onSearchIconClick
                      }, null, 8 /* PROPS */, ["onClick"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["modelValue", "onInput", "onClear"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createVNode(_component_q_select, {
                    modelValue: _ctx.filterByAlert,
                    "onUpdate:modelValue": [
                      _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterByAlert) = $event)),
                      _cache[4] || (_cache[4] = 
                    (val) => {
                      _ctx.selectedAlertFilter = val;
                    }
                  )
                    ],
                    options: _ctx.alertFilterOptions,
                    "option-label": "label",
                    "option-value": "value",
                    "map-options": "",
                    clearable: "",
                    "emit-value": "",
                    "bg-color": "white",
                    style: {"width":"210px"},
                    "input-style": {
                    fontFamily: 'Roboto',
                    fontSize: '12px',
                    lineHeight: '16px',
                  },
                    outlined: ""
                  }, null, 8 /* PROPS */, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createCommentVNode(" <q-btn\n                  outline\n                  rounded\n                  no-caps\n                  class=\"main-button q-mt-lg\"\n                  label=\"Export\"\n                  @click=\"onExportData\"\n                /> "),
                  _createVNode(_component_q_btn, {
                    dense: "",
                    class: "main-button q-mt-lg",
                    "no-caps": ""
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_24, [
                        _hoisted_25,
                        _createVNode(_component_q_icon, { name: "more_vert" })
                      ]),
                      _createVNode(_component_q_menu, {
                        "auto-close": "",
                        "transition-show": "jump-down",
                        "transition-hide": "jump-up"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_list, { style: {"min-width":"140px"} }, {
                            default: _withCtx(() => [
                              _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                clickable: "",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onExportData('excel')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _hoisted_26
                                    ]),
                                    _: 1 /* STABLE */
                                  })
                                ]),
                                _: 1 /* STABLE */
                              })), [
                                [_directive_close_popup]
                              ]),
                              _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                clickable: "",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onExportData('json')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _hoisted_27
                                    ]),
                                    _: 1 /* STABLE */
                                  })
                                ]),
                                _: 1 /* STABLE */
                              })), [
                                [_directive_close_popup]
                              ])
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ])
            ]),
            loading: _withCtx(() => [
              _createVNode(_component_q_inner_loading, {
                showing: "",
                label: "Loading data...",
                "label-class": "text-teal",
                "label-style": "font-size: 1.1em",
                color: "primary"
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["pagination", "rows", "columns", "filter", "loading", "onRequest"])
        ])
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_RealAlertPopin),
    _createVNode(_component_NormalBehaviorPopin)
  ]))
}